import React, { useState } from 'react';
import './Footer.css';
import ActivityModal from './ActivityModal';

const ACTIVITY_ENABLED = false;

function Footer() {
  const [showActivityModal, setShowActivityModal] = useState(false);

  const handleActivityClick = () => {
    if (!ACTIVITY_ENABLED) return;
    setShowActivityModal(true);
  };

  // 這裡原本的 JSX 結構有語法錯誤，因為 return 的多個元素沒有被單一父元素包裹。
  // 這會導致 React 編譯錯誤。常見的修正方式有兩種：
  // 1. 用 <div> 包起來
  // 2. 用 React.Fragment（<> </>）包起來
  // 這裡選擇用 <div>，因為這樣更容易做樣式管理，也符合語意。

  return (
    <div className="footer-container">
      <div className="home-colors">
        <div className="home-color">
            <img 
              src="/banner2.webp" 
              alt="ちいかわ開心代購" 
              className={`footer-banner-img${ACTIVITY_ENABLED ? ' clickable-banner' : ''}`}
              onClick={ACTIVITY_ENABLED ? handleActivityClick : undefined}
              style={ACTIVITY_ENABLED ? { cursor: 'pointer' } : undefined}
            />
        </div>
        <div className="home-color">
        <a href="https://www.instagram.com/maruwhite_space/" target="_blank" rel="noopener noreferrer">
          <img src="/banner3.webp" alt="ちいかわ開心代購" className="footer-banner-img"/>
        </a>
        </div>
        <div className="home-color">
          <img src="/banner4.webp" alt="ちいかわ開心代購" className="footer-banner-img"/>
        </div>
      </div>
      <div className="home-color-bar home-colors">
        <img 
          src="/banner5.webp" 
          alt="ちいかわ開心代購" 
          className="footer-banner-img2"
          onClick={() => window.open('https://lin.ee/YRbJFy7', '_blank', 'noopener,noreferrer')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      
      {ACTIVITY_ENABLED && (
        <ActivityModal 
          isOpen={showActivityModal} 
          onClose={() => setShowActivityModal(false)}
        />
      )}
    </div>
  );
}

export default Footer;
